import { DateField as BaseDateField } from '@wyz/ui';
import * as React from 'react';
import { useLocale } from '~/common/context';
import { useI18n } from '~/common/context';

type DateFieldProps = React.ComponentProps<typeof BaseDateField>;

const DateField: React.FC<Omit<DateFieldProps, 'translate' | 'locale'>> = (
  props,
) => {
  const { t } = useI18n();
  const locale = useLocale();

  return <BaseDateField {...props} translate={t} locale={locale.locale} />;
};

export default DateField;
